module.exports = __webpack_public_path__ + "static/media/test14_2.0be9c4a1.png";